import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation_types.js'

import { Storage } from '@/util/api/tools.js'
import { spaStateSync } from '@/util/api/modules/auth.js'
import { SKEY_TOKEN, SKEY_USERINFO } from '@/config/storage.config.js'

Vue.use(Vuex)

const state = {
  token: '',
  userinfo: {}
}

const getters = {
  userid (state) {
    return parseInt(state.userinfo.id) || 0
  },
  isLogin (state) {
    return state.userinfo && !!state.userinfo.id
  },
  isBindMobile (state) {
    return state.userinfo && /^1[34578]\d{9}$/.test(state.userinfo.verifiedMobile)
  },
  isInitPwd (state) {
    return state.userinfo && !!parseInt(state.userinfo.initPwd)
  }
}

const mutations = {
  [types.SET_TOKEN] (state, token) {
    state.token = token
  },
  [types.SET_USERINFO] (state, data) {
    let userinfo = data.userinfo || {}
    if (data.renew && data.renew === 'Y') {
      state.userinfo = Object.assign({}, userinfo)
    } else {
      state.userinfo = Object.assign({}, state.userinfo, userinfo)
    }
  }
}

const actions = {
  doLogout ({commit}) {
    return new Promise((resolve, reject) => {
      spaStateSync({method: 'logout'}).then(response => {
        commit(types.SET_TOKEN, '')
        commit(types.SET_USERINFO, {userinfo: {}, renew: 'Y'})
        Storage.remove(SKEY_TOKEN)
        Storage.remove(SKEY_USERINFO)
        resolve()
      }).catch(() => {
        reject(new Error('退出登录失败'))
      })
    })
  }
}

export function createStore () {
  return new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    getters,
    mutations,
    actions,
    modules: {}
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js